export default __webpack_public_path__ + "static/media/discord.ef8d9c88.png";